import { compose } from 'redux'

// higher-order components
import withRedux from './withRedux'
import withState from './withState'
import withEffects from './withEffects'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

export default compose(
  withRedux, // for modal state
  withState, // for managing logged in state
  withEffects, // for enabling/disabling button
  withEventHandlers // for button click handling
)(UI)
